import { Typography } from '@mui/material'

import clsx from 'clsx'
import { CombinedFormState } from '../../../../../modules/combinedForm/reducer'

import { useStyles } from './InstallmentsView.styles'
import { getLocalDateTime } from '../../../../../common/utils/dates'

interface InstallmentsViewProps {
  combinedFormData: CombinedFormState | undefined
  currencySymbol: string
  isCp: boolean
}

export const InstallmentsView = ({
  combinedFormData,
  currencySymbol,
  isCp,
}: InstallmentsViewProps) => {
  const { classes } = useStyles({ isCp })

  const installments = combinedFormData?.resellerAgreementData.installmentInfo

  return (
    <div className={clsx(classes.root, classes.elementsGap)}>
      <div className={classes.titleWraper}>
        <Typography className={clsx(classes.sectionText, classes.columnName)}>
          Invoice date
        </Typography>
        <Typography className={clsx(classes.sectionText, classes.columnPrice)}>
          Price to ISV
        </Typography>

        {isCp && (
          <Typography
            className={clsx(classes.sectionText, classes.columnBuyer)}
          >
            Price from buyer
          </Typography>
        )}
      </div>

      <div className={classes.border}></div>

      {installments?.map((installment, index) => {
        const { formattedDate } = getLocalDateTime(
          installment?.paymentDate as string
        )

        return (
          <div key={index}>
            <div className={classes.resourceRow} data-testid="dimensions-row">
              <div className={classes.resourcesContainer}>
                <div
                  className={classes.columnName}
                  key={`combinedFormData.resellerAgreementData.dimensions-${index}-paymentDate`}
                >
                  <div
                    className={clsx(classes.alignDescription, classes.wordWrap)}
                    data-testid="description-select"
                  >
                    <Typography className={classes.textClass}>
                      {formattedDate}
                    </Typography>
                  </div>
                </div>

                <div
                  key={`dimensions-${index}-quantity`}
                  className={clsx(classes.columnPrice)}
                >
                  <Typography
                    className={classes.textClass}
                    style={{ display: 'flex' }}
                  >
                    <span className={classes.currency}>{currencySymbol}</span>
                    {installment.amount}
                  </Typography>
                </div>
                {isCp && (
                  <div
                    key={`dimensions-${index}-quantity`}
                    className={clsx(classes.columnBuyer)}
                  >
                    <Typography
                      className={classes.textClass}
                      style={{ display: 'flex' }}
                    >
                      <span className={classes.currency}>{currencySymbol}</span>
                      {combinedFormData?.cppoData.installmentInfo[index].amount}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
            {index !== installments.length - 1 && (
              <div className={classes.border}></div>
            )}
          </div>
        )
      })}
    </div>
  )
}
